<onsip-header-main>
  <onsip-header-page-title>
    <button mat-icon-button color="primary" disableRipple [routerLink]="views.SAYSO_SETTINGS">
      <mat-icon>arrow_back_ios</mat-icon>
    </button>
    <span>{{ targetDisplay | async }}</span>
  </onsip-header-page-title>
  <onsip-header-action-bar>
    <button mat-stroked-button color="primary" (click)="delete()" [disabled]="deleting | async">
      <mat-icon>delete_outline</mat-icon>&nbsp;{{ "ONSIP_I18N.DELETE" | translate }}
    </button>
    <button
      mat-stroked-button
      color="primary"
      (click)="navigate(views.SAYSO_EDIT)"
      [disabled]="deleting | async"
    >
      <mat-icon>edit</mat-icon>&nbsp;{{ "ONSIP_I18N.EDIT_TOPIC" | translate }}
    </button>
    <button
      mat-stroked-button
      color="primary"
      (click)="navigate(views.SAYSO_DUPLICATE)"
      [disabled]="deleting | async"
    >
      <mat-icon>content_copy</mat-icon>&nbsp;{{ "ONSIP_I18N.DUPLICATE" | translate }}
    </button>
  </onsip-header-action-bar>
</onsip-header-main>

<onsip-fixed-width-card-list width="536px">
  <mat-card onsip-list-card>
    <mat-card-title
      >{{ "ONSIP_I18N.TOPIC_REPRESENTATIVES" | translate }} ({{
        (reps | async)!.length || 0
      }})</mat-card-title
    >
    <mat-card-content>
      <onsip-rep-list-view [reps]="(reps | async)!"></onsip-rep-list-view>
    </mat-card-content>
  </mat-card>

  <mat-card onsip-list-card>
    <mat-card-title>{{ "ONSIP_I18N.VIDEO_CALLS" | translate }}</mat-card-title>
    <mat-card-content>
      <onsip-video-checkbox-view [video]="(video | async)!"></onsip-video-checkbox-view>
    </mat-card-content>
  </mat-card>

  <mat-card onsip-list-card>
    @switch (true) {

    <!-- WHITELIST -->
    @case ((whitelistCountries | async) && (whitelistCountries | async)!.length > 0) {
    <mat-card-title>
      {{ "ONSIP_I18N.AVAILABLE_COUNTRIES" | translate }} ({{
        (whitelistCountries | async)!.length
      }})
    </mat-card-title>
    <mat-card-content>
      <onsip-country-list-view
        [countries]="(whitelistCountries | async)!"
      ></onsip-country-list-view>
    </mat-card-content>
    }
    <!-- BLACKLIST -->
    @case ((blacklistCountries | async) && (blacklistCountries | async)!.length > 0) {

    <mat-card-title>
      {{ "ONSIP_I18N.BLOCKED_COUNTRIES" | translate }} ({{ (blacklistCountries | async)!.length }})
    </mat-card-title>
    <mat-card-content>
      <onsip-country-list-view
        [countries]="(blacklistCountries | async)!"
      ></onsip-country-list-view>
    </mat-card-content>
    }
    <!-- NEITHER WHITELIST NOR BLACKLIST -->
    @default {
    <mat-card-title>
      {{ "ONSIP_I18N.AVAILABLE_COUNTRIES" | translate }}
    </mat-card-title>
    <mat-card-content>
      <onsip-country-list-view></onsip-country-list-view>
    </mat-card-content>
    } }
  </mat-card>

  <mat-card onsip-list-card>
    <mat-card-title>{{ "ONSIP_I18N.BUSINESS_HOURS" | translate }}</mat-card-title>
    <mat-card-content>
      <onsip-bhr-list-view [bhr]="(bhr | async)!"></onsip-bhr-list-view>
    </mat-card-content>
  </mat-card>

  <mat-card onsip-list-card>
    <mat-card-title>{{ "ONSIP_I18N.HOLIDAYS" | translate }}</mat-card-title>
    <mat-card-content>
      <onsip-holiday-list-view [holidays]="(holidays | async)!"></onsip-holiday-list-view>
    </mat-card-content>
  </mat-card>

  <mat-card onsip-list-card>
    <mat-card-title>{{ "ONSIP_I18N.URL_DISPLAY_RULES" | translate }}</mat-card-title>
    <mat-card-content>
      <onsip-page-rule-view [pages]="(pages | async)!"></onsip-page-rule-view>
    </mat-card-content>
  </mat-card>
</onsip-fixed-width-card-list>
